import { render, staticRenderFns } from "./BeforeDematSru.vue?vue&type=template&id=a197185c&"
import script from "./BeforeDematSru.vue?vue&type=script&lang=js&"
export * from "./BeforeDematSru.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports